<template>
    <!-- Modal -->
    <div class="modal fade" :id="id" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <slot name="title">
                        <h5 class="modal-title" id="exampleModalLabel">Potwierdzenie</h5>
                    </slot>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <slot name="body">
                        Czy na pewno?
                    </slot>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-orange" data-dismiss="modal" @click="$emit('yes')">Tak</button>
                    <button type="button" class="btn btn-outline-grey" data-dismiss="modal" @click="$emit('no')">Nie</button>
                </div>
            </div>
        </div>
    </div>
</template>



<script>
    export default {
        props: {
            id: {
                type: String,
                required: true
            },
        }
    }
</script>

<style lang="scss">
    .list-group-item, .list-group-item:hover{ z-index: auto; }
</style>



// WEBPACK FOOTER //
// PopUp.vue?667209cd